export const bangGia = {
  sections: {
    list: { title: 'Price books' },
    setup: { title: 'Price setup' },
    bookList: { title: 'Price books' },
    quanLy: { title: 'Price Book Management' },
    thietLap: { title: 'Price book setup' },
  },
  tabs: {
    info: 'Information',
    scope: 'Scope',
    books: 'Price books',
    products: 'Product prices',
  },
  fields: {
    code: 'Price book code',
    name: 'Price book name',
    startDate: 'Start date',
    endDate: 'End date',
    status: 'Status',
    createdAt: 'Created at',
    updatedAt: 'Updated at',
    onOffAction: 'On/Off',
    actions: 'Actions',
    formulaBase: 'Base price',
    formulaOp: 'Operator',
    formulaValue: 'Value',
    formulaUnit: 'Unit',
    allowOutOfCatalog: 'Allow items outside catalog',
    warnOutOfCatalog: 'Warn for items outside catalog',
    branches: 'Applicable branches',
    productCode: 'Item code',
    productName: 'Item name',
    unit: 'Unit',
    productGroup: 'Category',
    costPrice: 'Cost',
    lastPurchasePrice: 'Last purchase price',
    commonPrice: 'General price',
    salePrice: 'Sale price',
    stock: 'Stock',
  },
  sections2: {
    validity: 'Validity',
    formula: 'Price formula',
    formulaDesc:
      'Build a formula based on cost, last purchase price, or sale price from other price books',
    cashier: 'When cashiers create orders with this price book',
    scopeBranch: 'Branch',
    scopeCustomerGroup: 'Customer group',
    scopeCreator: 'Created by',
  },
  placeholders: {
    name: 'Enter price book name',
    branch: 'Select branches',
    customerGroup: 'Select customer groups',
    creator: 'Select creators',
    search: 'Search',
    selectPriceBook: 'Select price book',
  },
  radio: {
    all: 'All',
    specific: 'specific',
    branchAllSystem: 'All branches',
    branchSpecific: 'Specific branches',
    customerGroupAll: 'All',
    customerGroupSpecific: 'Specific customer groups',
    creatorAll: 'All',
    creatorSpecific: 'Specific creators',
    allowOutOfCatalog: 'Allow adding items not in this price book',
    warnWhenOutOfCatalog: 'Warn when adding items not in this price book',
    onlyInCatalog: 'Only allow items in this price book',
    apDung: 'Active',
    chuaApDung: 'Inactive',
  },
  formula: {
    baseEquals: 'New price =',
    to: 'to',
    add: 'Plus',
    remove: 'Minus',
    selectPriceBook: 'Select price book',
    giaVon: 'Cost',
    giaNhapCuoi: 'Last purchase',
    searchPlaceholder: 'Search',
  },
  status: {
    AP_DUNG: 'Active',
    CHUA_AP_DUNG: 'Inactive',
    all: 'All',
  },
  sort: {
    ma: 'Code',
    ten: 'Name',
    ngayTao: 'Created at',
  },
  filter: {
    searchPlaceholder: 'Code or name',
    statusSection: 'Status',
    sortSection: 'Sort',
    sortField: 'Sort field',
    sortDir: 'Sort dir',
    productSearch: 'Item code / name',
    maHangHoa: 'Item code',
    tenHangHoa: 'Item name',
    maNhomHang: 'Group code',
    tenNhomHang: 'Group name',
    group: 'Group',
    stockSection: 'Stock',
    priceCompareSection: 'Price compare',
  },
  tonKho: {
    TAT_CA: 'All',
    CON_HANG: 'In stock',
    HET_HANG: 'Out of stock',
  },
  dieuKienGia: {
    NHO_HON: 'Less than',
    LON_HON: 'Greater than',
    BANG: 'Equal',
    NHO_HON_HOAC_BANG: '≤',
    LON_HON_HOAC_BANG: '≥',
  },
  giaSoSanh: {
    GIA_VON: 'Cost',
    GIA_NHAP_CUOI: 'Last purchase',
  },
  loaiGiaGoc: {
    GIA_VON: 'Cost',
    GIA_NHAP_CUOI: 'Last purchase',
  },
  toanTu: {
    CONG: 'Plus (+)',
    TRU: 'Minus (−)',
    NHAN: 'Multiply (×)',
    CHIA: 'Divide (÷)',
  },
  donVi: {
    VND: 'VND',
    PERCENT: '%',
  },
  titles: {
    add: 'Add price book',
    edit: 'Edit price book',
    detail: 'Price book detail',
    priceList: 'Item prices',
    editPrice: 'Edit sale price',
    applyFormula: 'Apply price formula',
  },
  actions: {
    skip: 'Skip',
    save: 'Save',
    downloadTemplate: 'Download Excel template',
    importPrice: 'Import (Excel)',
    exportPrice: 'Export (Excel)',
    applyFormula: 'Apply formula',
    toggleColumns: 'Show/hide columns',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  columnSections: {
    productInfo: 'Product info',
    priceBooks: 'Price books',
  },
  messages: {
    noData: 'No data',
    loadError: 'Failed to load',
    loadDetailError: 'Failed to load detail',
    createSuccess: 'Created price book',
    updateSuccess: 'Updated price book',
    deleteSuccess: 'Deleted price book',
    toggleSuccess: 'Status changed',
    priceUpdateSuccess: 'Sale price updated',
    formulaSuccess: 'Formula applied',
    importSuccess: 'Imported successfully',
    importFailed: 'Price import failed',
    importEmpty: 'No price rows found in the file',
    importNoSheet: 'Excel file has no data sheet',
    importDescription:
      'Download the template (SKU, name, optional Common price + price-book columns). Missing price-book columns are created automatically (name only). Empty cells are skipped.',
    exportSuccess: 'Downloading',
    confirmDelete: 'Delete price book "{name}"?',
    listSummary: '{count} price books',
    gridSummary: '{count} items',
    selectBook: 'Select a price book in the sidebar to view and edit prices.',
    noPriceBooks: 'No price books yet. Add a price book to set product prices.',
    multiBookHint:
      'Showing {count} price books — each adds a price column. The first book drives pagination.',
    confirmApplyFormula: 'Apply formula to all items in this price book?',
    nameRequired: 'Please enter price book name',
    nameDuplicate: 'Price book name already exists',
    formulaRequired: 'Please select base price',
    dateRangeInvalid: 'End date must be after start date',
    scopeBranchRequired: 'Please select applicable branches',
  },
  cellPrice: {
    applyThisOnly: 'Apply formula to this item',
    applyPage: 'Apply formula to all items on this page',
    applyAll: 'Apply formula to all items',
    computeFromFormula: 'Compute price from formula',
    apply: 'Apply',
  },
  tooltips: {
    onlyInCatalogHint:
      'When this option is on, cashiers can only pick items in this price book. Items outside the price book will be hidden/grayed-out on the POS.',
  },
}
